import { SeverityLevel } from '@sentry/angular-ivy';
import { HttpErrorResponse } from '@angular/common/http';
/**
 * level : "fatal" | "error" | "warning" | "log" | "info" | "debug"
 */
export class MainHttpErrorResponse extends HttpErrorResponse {
  constructor(
    public message: string,
    public data: {
      level: SeverityLevel; 
      tags: { [key: string]: string };
      extra: {
        url: string;
        method: string;
        status: number;
        errorMessage: string;
      };
    }
  ) {
    super({ error: message, status: data.extra.status, statusText: data.extra.errorMessage, url: data.extra.url });
  }
}